// Marka portföyü (alt-marka) kovaları — TEK KAYNAK.
// Hem "Birleştirilmiş Kampanyalar" (UnifiedCampaigns) sayfasındaki "Marka Bazlı
// Günlük Bütçe" kırılımı, hem de Overview2'deki "Marka Bazlı Harcama" tablosu
// bu listeyi kullanır. Yeni marka/keyword tek yerden eklenir, iki sayfa da güncel kalır.
//
// Her perakendeci farklı bir marka portföyü sattığı için liste PER-BRAND'dir.
// Kısa token'lar ("ON" gibi) yanlış pozitifi ("LONDON") önlemek üzere kelime-sınırlı
// eşlenir (bkz. matchBrand). İki kelimeli markalar ayırt edici token'la (`match`)
// eşlenir: "SteveMadden"/"Steve Madden" → "MADDEN".

import { segmentMatchesBrand } from '../utils/brandKey';

export const HIGH5_BRAND_ID = 'b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8';
export const KLAUD_BRAND_ID = 'e3250f9b-7015-4bb9-8ef7-eb860738aaae';

export const HIGH5_BRAND_GROUPS = [
  { key: 'ON', label: 'ON' },
  { key: 'ASICS', label: 'ASICS' },
  { key: 'SALOMON', label: 'SALOMON' },
  { key: 'SAUCONY', label: 'SAUCONY' },
  { key: 'SKECHERS', label: 'SKECHERS' },
  { key: 'BROOKS', label: 'BROOKS' },
  { key: 'HOKA', label: 'HOKA' },
  { key: 'DOXA', label: 'DOXA' },
  { key: 'FABLETICS', label: 'FABLETICS' },
  { key: 'UNNA', label: 'UNNA' },
  { key: 'SAYSKY', label: 'SAYSKY' },
  // Kampanya adları birleşik "NewBalance" kullanıyor → "NEWBALANCE" ile eşle.
  { key: 'NEW BALANCE', label: 'NEW BALANCE', match: 'NEWBALANCE' },
  // Kampanya adlarında ASCII "HAGLOFS"; görünen ad Haglöfs.
  { key: 'HAGLOFS', label: 'Haglöfs' },
  { key: '4T2', label: '4T2' },
  { key: 'WISE', label: 'WISE' },
  // ERP net satış dosyasından gelen markalar. Üçünün de kampanyası (harcaması) var,
  // "Diğer" kovasında kalmamaları için listeye alındı.
  { key: 'OAKLEY', label: 'OAKLEY' },
  { key: 'CAMELBAK', label: 'CAMELBAK' },
  // Kampanya adlarında bitişik "PEAKDESIGN" → NEW BALANCE ile aynı durum.
  { key: 'PEAK DESIGN', label: 'PEAK DESIGN', match: 'PEAKDESIGN' },
  { key: 'BIOLITE', label: 'BIOLITE' },
];

export const KLAUD_BRAND_GROUPS = [
  { key: 'ASICS', label: 'ASICS' },
  { key: 'SKECHERS', label: 'SKECHERS' },
  { key: 'CLARKS', label: 'CLARKS' },
  { key: 'HOKA', label: 'HOKA' },
  { key: 'HUNTER', label: 'HUNTER' },
  { key: 'BIRKENSTOCK', label: 'BIRKENSTOCK' },
  { key: 'BROOKS', label: 'BROOKS' },
  { key: 'CAMPER', label: 'CAMPER' },
  { key: 'TIMBERLAND', label: 'TIMBERLAND' },
  { key: 'STEVE MADDEN', label: 'STEVE MADDEN', match: 'MADDEN' },
  { key: 'ECCO', label: 'ECCO' },
  { key: 'EMU AUSTRALIA', label: 'EMU AUSTRALIA', match: 'EMU' },
  { key: 'SAUCONY', label: 'SAUCONY' },
  { key: 'CROCS', label: 'CROCS' },
  { key: 'SALOMON', label: 'SALOMON' },
];

export const WUNDER_BRAND_ID = '9e1cb4b4-6a46-44ec-85b5-652665a4bd2b';
// Sıra ÖNEMLİ: ilk eşleşen kova kazanır. Alt-çizgi/model adları ana markaya
// yazılır (Dunk → NIKE, Samba → ADIDAS, Mostro → PUMA); iş birliği kampanyaları
// da ana markaya gider (adidasXBAPE → ADIDAS, CecilieBahnsenXasics → ASICS),
// bunu matchBrand'in "X" collab sınırı hallediyor.
export const WUNDER_BRAND_GROUPS = [
  { key: 'JORDAN', label: 'JORDAN' },
  // Dunk/Air Force/Air Max Nike modelleri; bazı kampanyalarda "Nike" geçmiyor.
  { key: 'NIKE', label: 'NIKE', match: ['NIKE', 'DUNK', 'AIR FORCE', 'AIR MAX'] },
  // Y-3 adidas'ın çizgisi ama mağazada ayrı marka gibi satılıyor → kendi kovası.
  // ADIDAS'tan ÖNCE gelmeli.
  { key: 'Y-3', label: 'Y-3', match: ['Y-3', 'Y3'] },
  { key: 'ADIDAS', label: 'ADIDAS', match: ['ADIDAS', 'ADISTAR', 'SAMBA', 'HANDBALL SPEZIAL'] },
  // "NEW BALANCE" tek pattern yeter: boşluk artık [ _-]* olarak eşleniyor →
  // NewBalance / New Balance / New-Balance hepsi yakalanır.
  { key: 'NEW BALANCE', label: 'NEW BALANCE' },
  { key: 'ASICS', label: 'ASICS' },
  // "PumaMostro" bitişik yazılıyor → ayrıca tam token olarak da eşleştir.
  { key: 'PUMA', label: 'PUMA', match: ['PUMA', 'PUMAMOSTRO', 'MOSTRO'] },
  { key: 'ON', label: 'ON' },
  { key: 'CONVERSE', label: 'CONVERSE' },
  { key: 'CARHARTT', label: 'CARHARTT' },
  { key: 'GRAMICCI', label: 'GRAMICCI' },
  { key: 'KRÜW', label: 'KRÜW', match: ['KRÜW', 'KRUW'] },
  { key: 'OAKLEY', label: 'OAKLEY' },
  { key: 'BIRKENSTOCK', label: 'BIRKENSTOCK' },
];

export const BRAND_GROUPS_BY_BRAND = {
  [HIGH5_BRAND_ID]: HIGH5_BRAND_GROUPS,
  [KLAUD_BRAND_ID]: KLAUD_BRAND_GROUPS,
  [WUNDER_BRAND_ID]: WUNDER_BRAND_GROUPS,
};

// UnifiedCampaigns uyumu: bilinmeyen markada HIGH5'e düşer (eski davranış).
export function getBrandGroups(brandId) {
  return BRAND_GROUPS_BY_BRAND[brandId] || HIGH5_BRAND_GROUPS;
}

// Overview2 için katı: yapılandırılmamış markada null (tablo gizlenir).
export function getBrandSpendGroups(brandId) {
  return BRAND_GROUPS_BY_BRAND[brandId] || null;
}

const brandRegexCache = new Map();

function brandRegex(pattern) {
  let re = brandRegexCache.get(pattern);
  if (re) return re;
  const escaped = pattern
    .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
    // Pattern'deki boşluk = "ayıraç olabilir de olmayabilir de":
    // "NEW BALANCE" → NewBalance / New Balance / New-Balance / New_Balance.
    .replace(/ /g, '[ _\\-]*');
  // Büyük/küçük harf duyarsız; iki yanda harf/rakam-olmayan sınır.
  // \b yerine manuel sınır (bazı Unicode'da \b bozuluyor).
  // Ek olarak "X" de sınır sayılır: iş birliği kampanyaları markaları ayıraçsız
  // birleştiriyor ("adidasXBAPE", "CecilieBahnsenXasics", "WunderXKrüw").
  re = new RegExp(`(^|[^A-Za-z0-9]|[Xx])${escaped}([^A-Za-z0-9]|[Xx]|$)`, 'i');
  brandRegexCache.set(pattern, re);
  return re;
}

// brandKey tek bir string ya da string dizisi olabilir (dizide herhangi biri tutarsa eşleşir).
export function matchBrand(name, brandKey) {
  if (!name || !brandKey) return false;
  const patterns = Array.isArray(brandKey) ? brandKey : [brandKey];
  // Önce mevcut sınırlı regex (kampanya adı, "adidasXBAPE" collab vb.); tutmazsa
  // backend brandKey kuralıyla segment bazlı normalize eşleşme: ciro etiketi "New Balance"
  // ↔ NEWBALANCE, "Say Sky" ↔ SAYSKY, "Haglöfs" ↔ HAGLOFS. Alt-dize eşleşmesi YOK.
  return patterns.some(p => brandRegex(p).test(name) || segmentMatchesBrand(name, p));
}
